import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoreFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.83301 8.75C6.52336 8.75 7.08301 9.30964 7.08301 10C7.08301 10.6904 6.52336 11.25 5.83301 11.25C5.1428 11.2498 4.58301 10.6902 4.58301 10C4.58301 9.30975 5.1428 8.75018 5.83301 8.75ZM10 8.75C10.6904 8.75 11.25 9.30964 11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75ZM14.167 8.75C14.8572 8.75018 15.417 9.30975 15.417 10C15.417 10.6902 14.8572 11.2498 14.167 11.25C13.4766 11.25 12.917 10.6904 12.917 10C12.917 9.30964 13.4766 8.75 14.167 8.75Z",
		fill: "currentColor"
	})
});
export default SvgMoreFill;
